// extracted by mini-css-extract-plugin
export var body = "_gr-5";
export var closeButton = "_gr-f";
export var container = "_gr-1";
export var content = "_gr-2";
export var cta = "_gr-c";
export var ctaLabel = "_gr-b";
export var eyebrow = "_gr-3";
export var howTo = "_gr-6";
export var image = "_gr-e";
export var modal = "_gr-0";
export var socialButton = "_gr-d";
export var stepCard = "_gr-8";
export var stepLabel = "_gr-a";
export var stepNumber = "_gr-9";
export var steps = "_gr-7";
export var title = "_gr-4";